import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import {
  Button,
  DialogContent,
  DialogTitle,
  Typography
} from "@mui/material"

import HKVMarkdown from "../../HKVMarkdown/4.0"
import HKVDialog from "../../HKVDialog/7.0"

import { addLocalStorage } from "../../../store/reducers/localStorage"
import { fetchLocalFile } from "../../../store/reducers/functions"

import { getAnalyticsId } from "../../../store/environment"

function HKVAnalytics() {
  const dispatch = useDispatch()

  const localStorage = useSelector((state) => state.localStorage)

  const [dialogConfig, setDialogConfig] = useState({})

  useEffect(() => {
    const analyticsId = getAnalyticsId()

    switch (localStorage?.consentAnalytics) {
      case "true":
        const script1 = document.createElement("script")
        script1.async = true
        script1.src = `https://www.googletagmanager.com/gtag/js?id=G-${analyticsId}`
        document.head.appendChild(script1)

        const script2 = document.createElement("script")
        script2.innerHTML = `
          window.dataLayer = window.dataLayer || []
          function gtag(){ dataLayer.push(arguments) }
          gtag('js', new Date())
          gtag('config', 'G-${analyticsId}')
        `
        document.head.appendChild(script2)
        break;

      case "false":
        break;

      default:
        openDialog("cookies", "xs")
        break;
    }
  }, [localStorage?.consentAnalytics])

  const openDialog = (key, size, options) => {
    const mergedOptions = { ...options, open: true, size: size ? size : "lg" }
    
    setDialogConfig(prevState => {
      prevState[key] = mergedOptions
      return { ...prevState }
    })
  }

  const closeDialog = (key, accepted = true) => {
    if (key === "cookies") {
      dispatch(addLocalStorage({ key: "consentAnalytics", value: accepted.toString() }))
    }

    setDialogConfig(prevState => {
      delete prevState[key]
      return { ...prevState }
    })
  }

  const openPrivacy = () => {
    dispatch(fetchLocalFile("/static/markdown/privacyverklaring.md?20250620", "text"))
      .then((md) => {
        openDialog("privacy", "lg", { source: md })
      })
  }

  const renderPrivacyDialog = () => {
    if (!dialogConfig.privacy) return

    const { source } = dialogConfig.privacy

    return (
      <HKVDialog
        config={dialogConfig.privacy}
        onClose={() => closeDialog("privacy")}
      >
        <DialogTitle>
          Privacyverklaring
        </DialogTitle>
        <DialogContent sx={{ display: "flex", flexDirection: "column" }}>
          <HKVMarkdown
            source={source}
            className="rich-text-full"
          />
          <div className="dialog-actions">
            <Button
              variant="contained"
              className="dialog-button"
              onClick={() => closeDialog("privacy")}
            >
              Sluit
            </Button>
          </div>
        </DialogContent>
      </HKVDialog>
    )
  }

  const renderCookiesDialog = () => {
    if (!dialogConfig.cookies) return

    return (
      <HKVDialog
        config={dialogConfig.cookies}
        onClose={() => closeDialog("cookies", false)}
      >
        <DialogTitle>
          Cookies
          <img
            src="/static/images/loader_analytics_consent.gif"
            title="Cookies"
            alt="Cookies"
            width={32} height={32}
            style={{ objectFit: "contain", verticalAlign: "middle" }}
          />
        </DialogTitle>
        <DialogContent sx={{ display: "flex", flexDirection: "column" }}>
          <Typography>Dankzij cookies krijgen we zicht op het gebruik van deze site en stelt ons in staat jouw gebruiksgemak te verbeteren.</Typography>
          <div className="dialog-actions">
            <Typography
              variant="caption"
              onClick={openPrivacy}
              sx={{
                margin: "auto auto auto 0",
                cursor: "pointer",
                "&:hover": {
                  textDecoration: "underline"
                }
              }}
            >
              Privacyverklaring
            </Typography>
            <Button
              variant="outlined"
              color="error"
              className="dialog-button"
              onClick={() => closeDialog("cookies", false)}
            >
              Weiger
            </Button>
            <Button
              variant="contained"
              color="primary"
              className="dialog-button"
              onClick={() => closeDialog("cookies", true)}
            >
              Accepteer
            </Button>
          </div>
        </DialogContent>
      </HKVDialog>
    )
  }

  return (
    <React.Fragment>
      {renderCookiesDialog()}
      {renderPrivacyDialog()}
    </React.Fragment>
  )
}

export default HKVAnalytics